import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
    methods: {
        inViewImage(elem) {
            gsap.to(elem, {
                scrollTrigger: {
                    trigger: elem,
                    start: "top 55%",
                },
                onStart:() => {
                    elem.classList.add('in-view')
                },
            });
        },
        fadeInUp(elem) {
            gsap.from(elem, {
                scrollTrigger: {
                    trigger: elem,
                    start: "top 70%",
                },
                duration: 1,
                ease: "power2.out",
                opacity: 0,
                y: 30,
            });
        },
        fadeInUpStagger(elem) {
            gsap.from(elem.childNodes, {
                scrollTrigger: {
                    trigger: elem,
                    start: "top 70%",
                },
                stagger: 0.1,
                duration: 1,
                ease: "power2.out",
                opacity: 0,
                y: 30,
            });
        },
        staggerText(elem) {
            gsap.from(elem.childNodes, {
                scrollTrigger: {
                    trigger: elem,
                    start: "top 70%",
                },
                stagger: 0.05,
                duration: 0.5,
                ease: "power2.out",
                opacity: 0,
            })
        },
        htmlToNode(str) {
            if (!str || typeof str !== 'string') return;
            const tmpElmt = document.createElement('div');
            tmpElmt.innerHTML = str;
            return tmpElmt.childNodes;
        },
        spanWrapText(target) {
            const nodes = this.htmlToNode(target)
            let returnText = '';
            for (const node of nodes) {
                if (node.nodeType === 3) {
                    const text = node.textContent.replace(/\r?\n/g, '');
                    returnText += text.split('').reduce((acc, v) => {
                        return acc + `<span>${v}</span>`
                    }, "");
                } else {
                    returnText = returnText + node.outerHTML
                }
            }
            return returnText;
        },
        spanWrapText2(target) {
            const nodes = [...target.childNodes];
            let returnText = '';
            for (const node of nodes) {
                if (node.nodeType === 3) {
                    const text = node.textContent.replace(/\r?\n/g, '');
                    returnText += text.split('').reduce((acc, v) => {
                        return acc + `<span>${v}</span>`
                    }, "");
                } else {
                    returnText = returnText + node.outerHTML
                }
            }
            return returnText;
        },
    }
}